// UI Component: Language Selector Dropdown
export class LanguageSelector {
  private dropdownElement: HTMLElement | null = null;
  private onSelectCallback?: (language: string) => void;

  private languages = [
    { id: 'javascript', name: 'JavaScript' },
    { id: 'typescript', name: 'TypeScript' },
    { id: 'python', name: 'Python' },
    { id: 'html', name: 'HTML' },
    { id: 'css', name: 'CSS' },
    { id: 'json', name: 'JSON' },
    { id: 'markdown', name: 'Markdown' },
    { id: 'xml', name: 'XML' },
    { id: 'yaml', name: 'YAML' },
    { id: 'shell', name: 'Shell Script' },
    { id: 'sql', name: 'SQL' },
    { id: 'php', name: 'PHP' },
    { id: 'java', name: 'Java' },
    { id: 'csharp', name: 'C#' },
    { id: 'cpp', name: 'C++' },
    { id: 'go', name: 'Go' },
    { id: 'rust', name: 'Rust' },
    { id: 'plaintext', name: 'Plain Text' },
  ];

  constructor() {
    this.createDropdown();
  }

  private createDropdown(): void {
    this.dropdownElement = document.createElement('div');
    this.dropdownElement.className = 'language-selector-dropdown';
    this.dropdownElement.innerHTML = `
      <div class="language-selector-header">Select Language</div>
      <div class="language-selector-list"></div>
    `;

    const listContainer = this.dropdownElement.querySelector('.language-selector-list')!;
    
    // Create language items
    this.languages.forEach((lang) => {
      const item = document.createElement('div');
      item.className = 'language-selector-item';
      item.textContent = lang.name;
      item.dataset.language = lang.id;
      
      item.addEventListener('click', () => {
        if (this.onSelectCallback) {
          this.onSelectCallback(lang.id);
        }
        this.hide();
      });
      
      listContainer.appendChild(item);
    });

    document.body.appendChild(this.dropdownElement);
    this.hide();

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (this.dropdownElement && !this.dropdownElement.contains(e.target as Node)) {
        this.hide();
      }
    });
  }

  show(anchorElement: HTMLElement): void {
    if (!this.dropdownElement) return;

    // Position dropdown near the anchor element
    const rect = anchorElement.getBoundingClientRect();
    this.dropdownElement.style.display = 'block';
    this.dropdownElement.style.left = `${rect.left}px`;
    this.dropdownElement.style.top = `${rect.bottom + 5}px`;

    // Adjust if off-screen
    const dropdownRect = this.dropdownElement.getBoundingClientRect();
    if (dropdownRect.right > window.innerWidth) {
      this.dropdownElement.style.left = `${window.innerWidth - dropdownRect.width - 10}px`;
    }
    if (dropdownRect.bottom > window.innerHeight) {
      this.dropdownElement.style.top = `${rect.top - dropdownRect.height - 5}px`;
    }
  }

  hide(): void {
    if (this.dropdownElement) {
      this.dropdownElement.style.display = 'none';
    }
  }

  onSelect(callback: (language: string) => void): void {
    this.onSelectCallback = callback;
  }

  highlightLanguage(languageId: string): void {
    const items = this.dropdownElement?.querySelectorAll('.language-selector-item');
    items?.forEach((item) => {
      if ((item as HTMLElement).dataset.language === languageId) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  destroy(): void {
    this.dropdownElement?.remove();
  }
}
